import { useTranslation } from 'react-i18next';

/**
 * Centralized toast message keys and helpers
 * Ensures consistent i18n usage across the application
 */
export const useToastMessages = () => {
  const { t } = useTranslation();

  return {
    // Common messages
    saving: () => t('saving') || 'Speichere...',
    error: () => t('error') || 'Fehler aufgetreten',
    success: () => t('success') || 'Erfolgreich',

    // Poem-related messages
    poemSaved: () => t('poemSaved') || 'Gedicht gespeichert!',
    poemUpdated: () => t('poemUpdated') || 'Gedicht aktualisiert!',
    poemDeleted: () => t('poemDeleted') || 'Gedicht gelöscht',
    poemError: () => t('error') || 'Fehler beim Speichern',

    // Contact form messages
    sending: () => t('contact.form.sending') || 'Sende...',
    messageSent: () => t('contact.form.success') || 'Nachricht gesendet!',
    messageError: () => t('contact.form.error') || 'Fehler beim Senden',
  };
};
